<template lang="pug">
DeliveryTime(
  :disable="disable",
  :mkad="mkad",
  :full="full",
  :deliveryTimes="$spbDeliveryTimes",
  @time="$emit('time', $event)",
  @deliveryTime="$emit('deliveryTime', $event)",
)
</template>

<script>
import DeliveryTime from '@/steps/step4/components/DeliveryTimeIntervals.vue'

export default {
  name: 'SpbDeliveryTime',
  components: {
    DeliveryTime,
  },
  unmounted() {
    this.$emit('commentOff')
  },
  props: {
    disable: Boolean,
    mkad: Boolean,
    full: Boolean,
    deliveryServiceId: {
      type: String,
      default: '',
    },
  },
}
</script>
